export default "__VITE_ASSET__6lDa9Oap__"